/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AccountLookupDTO,
  ApiDropdown,
  AuthenticatedStatusDTO,
  AuthenticatedUserDTO,
  AuthenticateUserRequestDTO,
  AuthenticateUserResponseDTO,
  AvailabilityCacheDTO,
  BookConfigurationDTO,
  BookingEngineServiceResponseDTO,
  CancelReservationRequestDTO,
  CancelReservationResponseDTO,
  ChangePasswordRequestDTO,
  CheckPromoCodeGroupRequestDTO,
  CheckPromoCodeGroupResponseDTO,
  CheckPromoCodeRequestDTO,
  CheckPromoCodeResponseDTO,
  CheckVoucherRequestDTO,
  CheckVoucherResponseDTO,
  CreateReservationRequestDTO,
  CreateReservationResponseDTO,
  CreateRestaurantBookingRequestDTO,
  CreateRestaurantBookingResponseDTO,
  CurrencyExchangeRateDTO,
  ErrorResponseDTO,
  ManageBookingConfigurationDTO,
  MathsChallengeDTO,
  PasswordResetRequestDTO,
  PasswordResetResponseDTO,
  PayByLinkConfigurationDTO,
  PayByLinkConfirmationResponseDTO,
  PayByLinkProcessRequestDTO,
  PayByLinkProcessResponseDTO,
  PayByLinkStatusResponseDTO,
  PayByLinkTransactionResponseDTO,
  PreCheckInConfigurationDTO,
  PreCheckInResponseDTO,
  PreCheckInStatusResponseDTO,
  PropertyConfigurationDTO,
  PropertyGroupConfigurationDTO,
  RegisterUserRequestDTO,
  RequestPasswordResetRequestDTO,
  RequestPasswordResetResponseDTO,
  ReservationConfirmationResponseDTO,
  ReservationStatusResponseDTO,
  RestaurantAvailabilityDTO,
  RestaurantDTO,
  RestaurantSetupDTO,
  RoomTypeConfigurationGroupDTO,
  SavePreCheckInRequestDTO,
  SavePreCheckInResponseDTO,
  SearchAreaAvailabilityPropertyResultDTO,
  SearchAreaAvailabilityRequestDTO,
  SearchAvailabilityPropertyResultDTO,
  SearchAvailabilityRequestDTO,
  SearchAvailabilityResultDTO,
  SearchDateOptionsRequestDTO,
  SearchDateOptionsResponseDTO,
  SearchReservationRequestDTO,
  SearchReservationResponseDTO,
  UpdateReservationRequestDTO,
  UpdateReservationResponseDTO,
  UpdateUserRequestDTO,
  UpgradeOptionsResponseDTO,
  UserDTO,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class Api<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
 * No description
 *
 * @tags Account
 * @name AccountStatus
 * @summary Check the account status and see if the user is authenticated.
If not user is authenticated, return the user details.
 * @request GET:/api/Account/Status
 */
  accountStatus = (
    query: {
      /** @format int32 */
      propertyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<AuthenticatedStatusDTO, void>({
      path: `/api/Account/Status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountGet
   * @summary Get the current user - return a 401 if not logged in.
   * @request GET:/api/Account
   */
  accountGet = (
    query: {
      /** @format int32 */
      propertyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<AuthenticatedUserDTO, void>({
      path: `/api/Account`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountAuthenticate
   * @summary Login the user
   * @request POST:/api/Account/Authenticate
   */
  accountAuthenticate = (model: AuthenticateUserRequestDTO, params: RequestParams = {}) =>
    this.request<AuthenticateUserResponseDTO, ErrorResponseDTO | void>({
      path: `/api/Account/Authenticate`,
      method: 'POST',
      body: model,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountLogout
   * @summary Log out the user
   * @request POST:/api/Account/Logout
   */
  accountLogout = (params: RequestParams = {}) =>
    this.request<void, ErrorResponseDTO | void>({
      path: `/api/Account/Logout`,
      method: 'POST',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRegister
   * @summary Register this user,
   * @request POST:/api/Account/Register
   */
  accountRegister = (model: RegisterUserRequestDTO, params: RequestParams = {}) =>
    this.request<UserDTO, ErrorResponseDTO | void>({
      path: `/api/Account/Register`,
      method: 'POST',
      body: model,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountRequestPasswordReset
   * @summary Request a password reset
   * @request POST:/api/Account/RequestPasswordReset
   */
  accountRequestPasswordReset = (request: RequestPasswordResetRequestDTO, params: RequestParams = {}) =>
    this.request<RequestPasswordResetResponseDTO, ErrorResponseDTO | void>({
      path: `/api/Account/RequestPasswordReset`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountUpdate
   * @summary Update a users details.
   * @request POST:/api/Account/Update
   */
  accountUpdate = (request: UpdateUserRequestDTO, params: RequestParams = {}) =>
    this.request<AuthenticatedUserDTO, ErrorResponseDTO | void>({
      path: `/api/Account/Update`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountChangePassword
   * @summary Change a users password
   * @request POST:/api/Account/ChangePassword
   */
  accountChangePassword = (request: ChangePasswordRequestDTO, params: RequestParams = {}) =>
    this.request<AuthenticatedUserDTO, ErrorResponseDTO | void>({
      path: `/api/Account/ChangePassword`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Account
   * @name AccountPasswordReset
   * @summary Perform a password reset
   * @request POST:/api/Account/PasswordReset
   */
  accountPasswordReset = (request: PasswordResetRequestDTO, params: RequestParams = {}) =>
    this.request<PasswordResetResponseDTO, ErrorResponseDTO | void>({
      path: `/api/Account/PasswordReset`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilitySearch
   * @summary Search for rooms available on these dates, for this number of guests
   * @request POST:/api/Availability/Search
   */
  availabilitySearch = (searchAvailability: SearchAvailabilityRequestDTO, params: RequestParams = {}) =>
    this.request<SearchAvailabilityResultDTO, void>({
      path: `/api/Availability/Search`,
      method: 'POST',
      body: searchAvailability,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilitySearchPropertyGroupAvailability
   * @summary Search accross the property group for rooms available on these dates, for this number of guests
   * @request POST:/api/Availability/SearchPropertyGroup
   */
  availabilitySearchPropertyGroupAvailability = (
    searchAvailability: SearchAvailabilityRequestDTO,
    params: RequestParams = {},
  ) =>
    this.request<SearchAvailabilityPropertyResultDTO, void>({
      path: `/api/Availability/SearchPropertyGroup`,
      method: 'POST',
      body: searchAvailability,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilityCheckPromoCode
   * @summary Check whether a promo code is valid for a property.
   * @request POST:/api/Availability/CheckPromoCode
   */
  availabilityCheckPromoCode = (checkPromoCodeRequest: CheckPromoCodeRequestDTO, params: RequestParams = {}) =>
    this.request<CheckPromoCodeResponseDTO, void>({
      path: `/api/Availability/CheckPromoCode`,
      method: 'POST',
      body: checkPromoCodeRequest,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilityCheckPromoCodeGroup
   * @summary Check whether a promo code is valid for a property.
   * @request POST:/api/Availability/CheckPromoCodeGroup
   */
  availabilityCheckPromoCodeGroup = (
    checkPromoCodeRequest: CheckPromoCodeGroupRequestDTO,
    params: RequestParams = {},
  ) =>
    this.request<CheckPromoCodeGroupResponseDTO, void>({
      path: `/api/Availability/CheckPromoCodeGroup`,
      method: 'POST',
      body: checkPromoCodeRequest,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilitySearchPropertyGroupAreaAvailability
   * @summary Search areas for room type availablity.
   * @request POST:/api/Availability/SearchPropertyGroupAreaAvailability
   */
  availabilitySearchPropertyGroupAreaAvailability = (
    searchAvailability: SearchAreaAvailabilityRequestDTO,
    params: RequestParams = {},
  ) =>
    this.request<SearchAreaAvailabilityPropertyResultDTO, void>({
      path: `/api/Availability/SearchPropertyGroupAreaAvailability`,
      method: 'POST',
      body: searchAvailability,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Availability
   * @name AvailabilityGet
   * @summary Load the availablity cache for this property for this period.
   * @request GET:/api/Availability
   */
  availabilityGet = (
    query: {
      /** @format int32 */
      propertyId: number;
      /** @format date-time */
      fromDate: string;
      /** @format date-time */
      toDate: string;
      languageCode?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AvailabilityCacheDTO[], void>({
      path: `/api/Availability`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Book
   * @name BookConfig
   * @summary Get book config information
   * @request GET:/api/Book/Config/{propertyId}
   */
  bookConfig = (propertyId: number, params: RequestParams = {}) =>
    this.request<BookConfigurationDTO, void>({
      path: `/api/Book/Config/${propertyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Company
   * @name CompanySearchCompanies
   * @summary Search for companies
   * @request GET:/api/Company/SearchCompanies
   */
  companySearchCompanies = (
    query: {
      /** @format int32 */
      propertyId: number;
      name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<AccountLookupDTO[], void>({
      path: `/api/Company/SearchCompanies`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags CurrencyExchangeRate
   * @name CurrencyExchangeRateGet
   * @summary Get the currenct list of exchange rates
   * @request GET:/api/CurrencyExchangeRate
   */
  currencyExchangeRateGet = (params: RequestParams = {}) =>
    this.request<CurrencyExchangeRateDTO[], void>({
      path: `/api/CurrencyExchangeRate`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingConfig
   * @summary Get the manage booking config
   * @request GET:/api/ManageBooking/Config/{propertyId}
   */
  manageBookingConfig = (propertyId: number, params: RequestParams = {}) =>
    this.request<ManageBookingConfigurationDTO, void>({
      path: `/api/ManageBooking/Config/${propertyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingSearchChallenge
   * @summary NEW: Returns a single-use math question for the reservation search.
   * @request GET:/api/ManageBooking/SearchChallenge
   */
  manageBookingSearchChallenge = (params: RequestParams = {}) =>
    this.request<MathsChallengeDTO, any>({
      path: `/api/ManageBooking/SearchChallenge`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingSearch
   * @summary Search for an existing reservation for editing.
   * @request POST:/api/ManageBooking/Search
   */
  manageBookingSearch = (input: SearchReservationRequestDTO, params: RequestParams = {}) =>
    this.request<SearchReservationResponseDTO, SearchReservationResponseDTO | void>({
      path: `/api/ManageBooking/Search`,
      method: 'POST',
      body: input,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingUpgradeOptions
   * @summary Get the possible upgrade options for this reservation
   * @request GET:/api/ManageBooking/UpgradeOptions
   */
  manageBookingUpgradeOptions = (
    query: {
      /** @format int32 */
      propertyId: number;
      /** @format int32 */
      reservationId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<UpgradeOptionsResponseDTO, void>({
      path: `/api/ManageBooking/UpgradeOptions`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingSearchDateOptions
   * @request POST:/api/ManageBooking/SearchDateOptions
   */
  manageBookingSearchDateOptions = (request: SearchDateOptionsRequestDTO, params: RequestParams = {}) =>
    this.request<SearchDateOptionsResponseDTO, void>({
      path: `/api/ManageBooking/SearchDateOptions`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingCancel
   * @summary Cancel an exisiting reservation
   * @request POST:/api/ManageBooking/Cancel
   */
  manageBookingCancel = (request: CancelReservationRequestDTO, params: RequestParams = {}) =>
    this.request<CancelReservationResponseDTO, CancelReservationResponseDTO | void>({
      path: `/api/ManageBooking/Cancel`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags ManageBooking
   * @name ManageBookingUpdate
   * @summary Update an exisiting reservation
   * @request POST:/api/ManageBooking/Update
   */
  manageBookingUpdate = (request: UpdateReservationRequestDTO, params: RequestParams = {}) =>
    this.request<UpdateReservationResponseDTO, void>({
      path: `/api/ManageBooking/Update`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PayByLink
   * @name PayByLinkConfig
   * @summary Get the pay by link config
   * @request GET:/api/PayByLink/Config/{propertyId}
   */
  payByLinkConfig = (propertyId: number, params: RequestParams = {}) =>
    this.request<PayByLinkConfigurationDTO, void>({
      path: `/api/PayByLink/Config/${propertyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PayByLink
   * @name PayByLinkStatus
   * @summary Get a pay by link transaction status - if true, then call the confirmation to get the full data.
   * @request GET:/api/PayByLink/Status
   */
  payByLinkStatus = (
    query: {
      /** @format int32 */
      propertyId: number;
      referenceNumber: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<PayByLinkStatusResponseDTO, void>({
      path: `/api/PayByLink/Status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PayByLink
   * @name PayByLinkConfirmation
   * @summary Get a pay by link confirmation - if created, then the pay by link data will be returned.
   * @request GET:/api/PayByLink/Confirmation
   */
  payByLinkConfirmation = (
    query: {
      /** @format int32 */
      propertyId: number;
      referenceNumber: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<PayByLinkConfirmationResponseDTO, void>({
      path: `/api/PayByLink/Confirmation`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PayByLink
   * @name PayByLinkGet
   * @summary Get the pay by link operation
   * @request GET:/api/PayByLink/Get
   */
  payByLinkGet = (
    query: {
      /** @format int32 */
      propertyId: number;
      invoiceNumber: string;
      hash: string;
      actionType: 'None' | 'Pay' | 'StoreCard';
      paymentId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<PayByLinkTransactionResponseDTO, PayByLinkTransactionResponseDTO | void>({
      path: `/api/PayByLink/Get`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PayByLink
   * @name PayByLinkProcess
   * @summary Get the pay by link operation
   * @request POST:/api/PayByLink/Process
   */
  payByLinkProcess = (request: PayByLinkProcessRequestDTO, params: RequestParams = {}) =>
    this.request<PayByLinkProcessResponseDTO, PayByLinkProcessResponseDTO | void>({
      path: `/api/PayByLink/Process`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PreCheckIn
   * @name PreCheckInConfig
   * @summary Get the precheck in config
   * @request GET:/api/PreCheckIn/Config/{propertyId}
   */
  preCheckInConfig = (propertyId: number, params: RequestParams = {}) =>
    this.request<PreCheckInConfigurationDTO, void>({
      path: `/api/PreCheckIn/Config/${propertyId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PreCheckIn
   * @name PreCheckInGet
   * @summary Get a reservation or reservation Item for pre checkin
   * @request GET:/api/PreCheckIn/Get
   */
  preCheckInGet = (
    query: {
      /** @format int32 */
      propertyId: number;
      referenceNumber: string;
      hash: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<PreCheckInResponseDTO, PreCheckInStatusResponseDTO | void>({
      path: `/api/PreCheckIn/Get`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PreCheckIn
   * @name PreCheckInSave
   * @summary Save a reservation for Pre checkin
   * @request POST:/api/PreCheckIn/Save
   */
  preCheckInSave = (model: SavePreCheckInRequestDTO, params: RequestParams = {}) =>
    this.request<SavePreCheckInResponseDTO, void>({
      path: `/api/PreCheckIn/Save`,
      method: 'POST',
      body: model,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Property
   * @name PropertyGet
   * @summary Get property information
   * @request GET:/api/Property/{propertyIdOrCode}
   */
  propertyGet = (propertyIdOrCode: string, params: RequestParams = {}) =>
    this.request<PropertyConfigurationDTO, void>({
      path: `/api/Property/${propertyIdOrCode}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PropertyGroup
   * @name PropertyGroupGet
   * @summary Get property group information
   * @request GET:/api/PropertyGroup/{propertyGroupIdOrCode}
   */
  propertyGroupGet = (propertyGroupIdOrCode: string, params: RequestParams = {}) =>
    this.request<PropertyGroupConfigurationDTO, void>({
      path: `/api/PropertyGroup/${propertyGroupIdOrCode}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Reservation
   * @name ReservationCreate
   * @summary Create a reservation
   * @request POST:/api/Reservation/Create
   */
  reservationCreate = (request: CreateReservationRequestDTO, params: RequestParams = {}) =>
    this.request<CreateReservationResponseDTO, void>({
      path: `/api/Reservation/Create`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Reservation
   * @name ReservationStatus
   * @summary Get a reservation status - if true, then call the confirmation to get the full data.
   * @request GET:/api/Reservation/Status
   */
  reservationStatus = (
    query: {
      /** @format int32 */
      propertyId: number;
      referenceNumber: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ReservationStatusResponseDTO, void>({
      path: `/api/Reservation/Status`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Reservation
   * @name ReservationConfirmation
   * @summary Get a reservation confirmation - if created, then the reservation data will be returned.
   * @request GET:/api/Reservation/Confirmation
   */
  reservationConfirmation = (
    query: {
      /** @format int32 */
      propertyId: number;
      referenceNumber: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<ReservationConfirmationResponseDTO, void>({
      path: `/api/Reservation/Confirmation`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Reservation
   * @name ReservationCheckVoucherCode
   * @summary Check if a voucher code is valid and can be applied.
   * @request POST:/api/Reservation/CheckVoucherCode
   */
  reservationCheckVoucherCode = (request: CheckVoucherRequestDTO, params: RequestParams = {}) =>
    this.request<CheckVoucherResponseDTO, void>({
      path: `/api/Reservation/CheckVoucherCode`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags RestaurantBooking
   * @name RestaurantBookingGetRestaurants
   * @summary The list of available restaurants.
   * @request GET:/api/RestaurantBooking/Restaurants
   */
  restaurantBookingGetRestaurants = (
    query: {
      /** @format int32 */
      propertyId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RestaurantDTO[], void>({
      path: `/api/RestaurantBooking/Restaurants`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags RestaurantBooking
   * @name RestaurantBookingGetRestaurantSetup
   * @summary Get the setup for this restaurant on this date
   * @request GET:/api/RestaurantBooking/RestaurantSetup
   */
  restaurantBookingGetRestaurantSetup = (
    query: {
      /** @format int32 */
      propertyId: number;
      restaurantId: string;
      /** @format date-time */
      date: string;
      isReservation: boolean;
      /** @format int32 */
      identifier: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<RestaurantSetupDTO, void>({
      path: `/api/RestaurantBooking/RestaurantSetup`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags RestaurantBooking
   * @name RestaurantBookingGetAvailability
   * @summary Get the restaurant availability
   * @request GET:/api/RestaurantBooking/Availability
   */
  restaurantBookingGetAvailability = (
    query: {
      /** @format int32 */
      propertyId: number;
      restaurantId: string;
      /** @format date-time */
      date: string;
      /** @format int32 */
      partySize: number;
      currencySymbol: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RestaurantAvailabilityDTO[], void>({
      path: `/api/RestaurantBooking/Availability`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags RestaurantBooking
   * @name RestaurantBookingCreate
   * @summary Create a restaurant booking
   * @request POST:/api/RestaurantBooking/Create
   */
  restaurantBookingCreate = (request: CreateRestaurantBookingRequestDTO, params: RequestParams = {}) =>
    this.request<CreateRestaurantBookingResponseDTO, void>({
      path: `/api/RestaurantBooking/Create`,
      method: 'POST',
      body: request,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags RoomTypeConfiguration
   * @name RoomTypeConfigurationGet
   * @summary Load the room type configuration options for this property
   * @request GET:/api/RoomTypeConfiguration/Get
   */
  roomTypeConfigurationGet = (
    query: {
      /** @format int32 */
      propertyId: number;
      languageCode?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<RoomTypeConfigurationGroupDTO[], void>({
      path: `/api/RoomTypeConfiguration/Get`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Service
   * @name ServiceGet
   * @summary Get a list of services, and the available inventory for this date range.
   * @request GET:/api/Service/Get
   */
  serviceGet = (
    query: {
      /** @format int32 */
      propertyId: number;
      languageCode: string;
      /** @format int32 */
      roomTypeId: number;
      /** @format int32 */
      ratePlanId: number;
      /** @format date-time */
      dateOfArrival: string;
      /** @format date-time */
      dateOfDeparture: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<BookingEngineServiceResponseDTO, void>({
      path: `/api/Service/Get`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags Service
   * @name ServiceGetReservationItemServices
   * @summary Get a list of services, and the available inventory for a reservation Item
   * @request GET:/api/Service/GetReservationItemServices
   */
  serviceGetReservationItemServices = (
    query: {
      /** @format int32 */
      propertyId: number;
      languageCode: string;
      /** @format int32 */
      reservationItemId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<BookingEngineServiceResponseDTO, void>({
      path: `/api/Service/GetReservationItemServices`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StaticData
   * @name StaticDataCountries
   * @summary Get the countries for this property
   * @request GET:/api/StaticData/{propertyId}/countries
   */
  staticDataCountries = (propertyId: number, params: RequestParams = {}) =>
    this.request<ApiDropdown[], void>({
      path: `/api/StaticData/${propertyId}/countries`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StaticData
   * @name StaticDataCreditCardTypes
   * @summary Get the list of credit card types that are acceptable for this property.
   * @request GET:/api/StaticData/{propertyId}/creditcardtypes
   */
  staticDataCreditCardTypes = (propertyId: number, params: RequestParams = {}) =>
    this.request<ApiDropdown[], void>({
      path: `/api/StaticData/${propertyId}/creditcardtypes`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StaticData
   * @name StaticDataCancellationReasons
   * @summary Get the list of cancellation reasons that this property uses.
   * @request GET:/api/StaticData/{propertyId}/CancellationReasons
   */
  staticDataCancellationReasons = (propertyId: number, params: RequestParams = {}) =>
    this.request<ApiDropdown[], void>({
      path: `/api/StaticData/${propertyId}/CancellationReasons`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags StaticData
   * @name StaticDataFlush
   * @summary Flush the static data for this property from the cache
   * @request POST:/api/StaticData/{propertyId}/flush
   */
  staticDataFlush = (
    propertyId: number,
    query: {
      key: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<void, void>({
      path: `/api/StaticData/${propertyId}/flush`,
      method: 'POST',
      query: query,
      ...params,
    });
}
